export default {
    select_time: 'Select time',
}
